import { form } from "./form";

const {
  formField: {
    endpointUrl,
    triggerName,
    description,
    parameters,
    notes
  },
} = form;

const initialValues = {
  [endpointUrl.name]: "",
  [triggerName.name]: "",
  [description.name]: "",
  [parameters.name]: [],
  [notes.name]: "",
};

export default initialValues;